import { type FunctionComponent } from 'react';
import classes from './ProviderSearchHome.module.css';
import Image from 'next/image';
import { Stack } from '@mantine/core';
import ProviderSearchForm from '@/components/ProviderSearch/ProviderSearchForm';

const ProviderSearchHome: FunctionComponent = () => (
  <div className={classes.root}>
    <Image
      src="/images/nwd/homeFamily.jpg"
      priority={true}
      width={0}
      height={0}
      sizes="100vw"
      alt=""
      className={classes.bannerImage}
    />
    <Stack gap={8} flex={1}>
      <h1 className={classes.findCare}>Find Care</h1>
      <p className={classes.title}>
        Locate a Tier 1 Northwell Direct provider nearest you
      </p>
      <ProviderSearchForm />
    </Stack>
  </div>
);

export default ProviderSearchHome;
